import { validateProps } from '../../utils';
export const isValidCalendarDisplay = calendarDisplay => validateProps(calendarDisplay, ['id', 'displayName']);
//# sourceMappingURL=Calendar.js.map